import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';

import Version from '../../Config/Version'
import Envi from '../../Config/Environment'
import { useDispatch, useSelector } from 'react-redux'
import { getSpajs } from '../../store/features/SPAJSlice'
import { getCitySign, getParameterApps } from '../../store/features/OTPSlice'
import { Row, Col } from 'react-bootstrap';
import { getAddDays } from '../../component/Helper'
import './welcomestyles.css';
import Spinners from '../../component/Spinner/spinners';

const Welcome = () => {
    let navigate = useNavigate();
    const SPAJNumber = useParams();
    const { SPAJs } = useSelector((state) => state.SPAJs);
    const { Parameter } = useSelector((state) => state.Params);
    const { CitySign } = useSelector((state) => state.CitySign);
    const [loadingSPAJ, setLoadingSPAJ] = useState(true);
    const [loadingParameter, setLoadingParameter] = useState(true);
    const [loading, setLoading] = useState(true);
    const [expired, setExpired] = useState(false);
    const [reject, setReject] = useState(false);
    const [inforce, setInforce] = useState(false);
    const [inprocess, setInProcess] = useState(false);
    const [accountNumber, setAccountNumber] = useState('-');
    const [codeNumber, setCodeNumber] = useState('-');
    const [pending , setPending ] = useState(false);
    const [pendingDoc , setPendingDoc ] = useState(false);
    const [PEUnitlink , setPEUnitlink ] = useState(false);
    const [PEPremiUnitlink , setPEPremiUnitlink ] = useState(false);
    const [otherstat, setOtherStat] = useState(false);
    const [invalidStat, setInvalidStat] = useState(false);
    const [serverStat, setServerStat] = useState(false);
    const [serverTitle, setServerTitle] = useState(null);
    const [serverContent, setServerContent] = useState(null);

    const [invalidWording, setInvalidWording] = useState("");

    const dispatch = useDispatch();

    const handleCopyClick = async () => {
        try {
            await window.navigator.clipboard.writeText(SPAJs?.spajHeader?.accountNumber);
            alert("Copied to clipboard!");
        } catch (err) {
            console.error(
                "Unable to copy to clipboard.",
                err
            );
            alert("Copy to clipboard failed.");
        }
    };

    useEffect(() => {
        setLoading(true);
        if (SPAJNumber.id != null) {
            let tmpReq = {
                spajNumber: SPAJNumber.id
            }
            localStorage.setItem("spajHash", SPAJNumber.id);

            // GET DETAIL SPAJ HEADER
            dispatch(getSpajs(tmpReq)).then(res => {
                setLoadingSPAJ(false);
                localStorage.setItem("SPAJ_HEADER", JSON.stringify(res.payload.data.spajHeader));
            }).catch(err => {
                setLoadingSPAJ(false);
            })
        } else {
            setLoadingSPAJ(false);
        }

        // GET SYSTEM PARAMETER=
        dispatch(getParameterApps()).then(res => {
            setLoadingParameter(false);
        }).catch(err => {
            setLoadingSPAJ(false);
        });

        dispatch(getCitySign()).then(res => {
            setLoadingParameter(false);
        }).catch(err => {
            setLoadingSPAJ(false);
        });

        //
    }, [SPAJNumber])

    const navigatePage = () => {
        navigate( "/otp");
    }



    useEffect(() => {
        if (!loadingParameter && !loadingSPAJ) {
            setLoading(false);

            // Check Expired Send Mail Date
            let sendMailDate = new Date(SPAJs?.spajHeader?.SentMailDate);
            let expiredDateParam = Parameter.dataParameterApps.find(param => {
                if (param.codeSetting == "URL_EXPIRED")
                    return true;
            })
            let expiredMailDate = new Date(getAddDays(sendMailDate, expiredDateParam.valueSetting));
            let today = new Date();
            today.setHours(0, 0, 0, 0);

            if (today > expiredMailDate) {
                setExpired(true);
            }

            // Check Status Reject
            let status = SPAJs?.spajHeader?.statusCustomer;
            let isValid = SPAJs?.spajValid?.validFlag;
            let isMaintenance = SPAJs?.statusServer?.status;
            if(isMaintenance)
            {
                setServerTitle(SPAJs?.statusServer?.title)
                setServerContent(SPAJs?.statusServer?.content)
            }
            console.log(isMaintenance)
            if(isMaintenance && isMaintenance !== "online") {
                setServerStat(true)
            }
            else{
                if (isValid === 1)
                {
                    if (status == "RJC" || status == "RJP") {
                        setReject(true);
                    }
                    else if(status =="INP" || status =="IN"){
                        setInProcess(true)
                        setAccountNumber(SPAJs?.spajHeader?.accountNumber)
                        setCodeNumber(SPAJs?.spajHeader?.accountNumber.substring(0,5).includes("84082") ? "BNI" : SPAJs?.spajHeader?.accountNumber.substring(0,5).includes("15310") ? " BRI" : SPAJs?.spajHeader?.accountNumber.substring(0,5).includes("89065") ? " Mandiri" : "BCA");
                    }
                    else if(status =="IF"){
                        setInforce(true)
                    }
                    else if(status == "WD" || status == "PP" || status == "DC" || status == "NTU"){
                        setOtherStat(true)
                    }
                    else if(status == "PE") {
                        setPending(true);
                    } 
                    else if(status == "PDC") {
                        setPendingDoc(true);
                    }
                    else if(status == "PEP") {
                        if (SPAJs?.spajHeader?.isUnitLink == 0) {
                            setOtherStat(true)
                        }else{
                            setPEPremiUnitlink(true)
                        }
                    }
                }
                else
                {
                    setInvalidStat(true);
                    setInvalidWording(SPAJs?.spajValid?.errMsg)
                }
            }
        }
    }, [loadingSPAJ, loadingParameter])

    const ReturnData = () => {
        if (SPAJNumber.id == null || SPAJs?.spajHeader == null) {
            return (
                <>
                    <div className='logo-posisi'>
                        <img src="/images/generali-white.png" className='size-logo' />
                    </div>
                    <div className='position-cardfooter'>
                        <div className="card-container-welcome shadow-lg">

                            <div className='bold fs-16 text-center'>Selamat Datang!</div>
                            <div className='mt-2'>
                                <div className='fs-12 text-center'>Mohon gunakan link yang telah dikirimkan Generali ke nomor handphone dan email terdaftar Anda.</div>
                            </div>
                        </div>
                        <div className='logo-link-welcome'>
                            <div>www.generali.co.id</div>
                        </div>
                    </div>
                    <div className='version'>
                        <div>{Version.appName} Version {Version.appVersion} {Envi.appStatus==="PROD"? "": "UAT"}</div>  
                    </div>
                </>
            )
        }

        if (reject) {
            return (
                <>
                    {
                        <>
                            <div className='logo-posisi'>
                                <img src="/images/generali-white.png" className='size-logo' />
                            </div>
                            <div className='position-cardfooter'>
                                <div className="card-container-welcome shadow-lg">

                                    <div className='bold fs-16 text-center'>{SPAJs.spajHeader.gender == "M" ? 'Bapak' : 'Ibu'} {SPAJs.spajHeader.firstName} No SPAJ {SPAJs.spajHeader.spajNumber}</div>
                                    <div className='mt-2'>
                                        <div className='fs-12 text-center'>Surat Pengajuan Asuransi Jiwa (SPAJ) Anda sedang dalam proses perubahan data. Silakan menghubungi Agen Anda untuk informasi terkait SPAJ Anda</div>
                                    </div>
                                </div>
                                <div className='logo-link-welcome'>
                                    <div>www.generali.co.id</div>
                                </div>
                            </div>
                            <div className='version'> 
                                <div>{Version.appName} Version {Version.appVersion} {Envi.appStatus==="PROD"? "": "UAT"}</div>  
                            </div>
                        </>
                    }
                </>
            )
        }

        if (inprocess && accountNumber === '-') {
            return (
                <>
                    <div className='logo-posisi'>
                        <img src="/images/generali-white.png" className='size-logo' />
                    </div>
                    <div className='position-cardfooter'>
                        <div className="card-container-welcome shadow-lg">
                        <div className='bold fs-16 text-center'>Terima Kasih</div>

                        <div className='mt-2'>
                            <div className='fs-12 text-center'>Atas kepercayaan Anda telah memilih Generali Indonesia. <br/>
                            Surat Pengajuan Asuransi Jiwa (SPAJ) Anda dengan No {SPAJs.spajHeader?.spajNumber} sedang dalam proses. <br/>
                            Silakan menghubungi Agen Anda untuk informasi terkait SPAJ Anda. </div>
                        </div>
                        </div>
                        <div className='logo-link-welcome'>
                            <div>www.generali.co.id</div>
                        </div>
                    </div>
                    <div className='version'>
                        <div>{Version.appName} Version {Version.appVersion} {Envi.appStatus==="PROD"? "": "UAT"}</div>  
                    </div>

                </>
            )
        }

        if (inprocess && accountNumber !== '-') {
            return (
                <>
                    <div className='logo-posisi'>
                        <img src="/images/generali-white.png" className='size-logo' />
                    </div>
                    <div className='position-cardfooter'>
                        <div className="card-container-welcome shadow-lg">
                        <div className='bold fs-16 text-center'>Terima Kasih</div>

                        <div className='mt-2'>
                            <div className='fs-12 text-center'>Atas kepercayaan Anda telah memilih Generali Indonesia. <br/>
                            Selanjutnya, silakan lakukan pembayaran premi pertama Anda melalui Virtual Account {SPAJs.spajHeader?.isSyariah === 1 ? 'Permata' : codeNumber}<br/>
                            <div style={{color:'#0000FF'}} onClick={handleCopyClick}><u><b>No. VA {accountNumber}</b></u><br/></div>
                            Apabila pembayaran sudah dilakukan, silakan hubungi Agen Anda untuk status pengajuan Surat Pengajuan Asuransi Jiwa (SPAJ) Anda terkini.</div>
                        </div>
                        </div>
                        <div className='logo-link-welcome'>
                            <div>www.generali.co.id</div>
                        </div>
                    </div>
                    <div className='version'>
                        <div>{Version.appName} Version {Version.appVersion} {Envi.appStatus==="PROD"? "": "UAT"}</div>  
                    </div>

                </>
            )
        }

        if (PEUnitlink) {
            return (
                <>
                    <div className='logo-posisi'>
                        <img src="/images/generali-white.png" className='size-logo' />
                    </div>
                    <div className='position-cardfooter'>
                        <div className="card-container-welcome shadow-lg">

                        {serverTitle !== null && serverTitle !== undefined &&
                                <div className='mt-2'>
                                    <div className='fs-12 text-center'>{serverContent}</div>
                                </div>                            
                            }


                        <div className='bold fs-16 text-center'>Selamat Datang</div>

                            <div className='mt-2'>
                                <div className='fs-12 text-center'>Terima kasih atas kepercayaan Anda memilih Generali Indonesia. <br/>
                                Surat Pengajuan Asuransi Jiwa (SPAJ) Anda dengan No {SPAJs.spajHeader?.spajNumber} sedang dalam proses. <br/>
                                namun terdapat kekurangan persyaratan/informasi/dokumen yang harus dilengkapi. <br/>
                                Silakan menghubungi Agen Anda untuk informasi terkait SPAJ Anda.
                                </div>

                            </div>
                            <div className='mt-2'>
                                <button className='button-red' onClick={() => navigatePage()}>Mulai</button>
                            </div>
                        </div>
                        <div className='logo-link-welcome'>
                            <div>www.generali.co.id</div>
                        </div>
                    </div>
                    <div className='version'>
                        <div>{Version.appName} Version {Version.appVersion} {Envi.appStatus==="PROD"? "": "UAT"}</div>  
                    </div>

                </>
            )
        }

        if (pending) {
            return (
                <>
                    <div className='logo-posisi'>
                        <img src="/images/generali-white.png" className='size-logo' />
                    </div>
                    <div className='position-cardfooter'>
                        <div className="card-container-welcome shadow-lg">
                        <div className='bold fs-16 text-center'>Selamat Datang</div>

                            <div className='mt-2'>
                                <div className='fs-12 text-center'>Terima kasih atas kepercayaan Anda memilih Generali Indonesia. <br/>
                                Surat Pengajuan Asuransi Jiwa (SPAJ) Anda dengan No {SPAJs.spajHeader?.spajNumber} sedang dalam proses. <br/>
                                namun terdapat kekurangan persyaratan/informasi/dokumen yang harus dilengkapi. <br/>
                                Silakan menghubungi Agen Anda untuk informasi terkait SPAJ Anda.
                                </div>

                            </div>
                        </div>
                        <div className='logo-link-welcome'>
                            <div>www.generali.co.id</div>
                        </div>
                    </div>
                    <div className='version'>
                        <div>{Version.appName} Version {Version.appVersion} {Envi.appStatus==="PROD"? "": "UAT"}</div>  
                    </div>

                </>
            )
        }

        if (PEPremiUnitlink) {
            return (
                <>
                    <div className='logo-posisi'>
                        <img src="/images/generali-white.png" className='size-logo' />
                    </div>
                    <div className='position-cardfooter'>
                        <div className="card-container-welcome shadow-lg">

                        {serverTitle !== null && serverTitle !== undefined &&
                            <div className='bold fs-16 text-center'>{serverTitle}</div>
                        }
                        {serverTitle !== null && serverTitle !== undefined &&
                            <div className='mt-2'>
                                <div className='fs-12 text-center'>{serverContent}<hr></hr></div>
                            </div>                            
                        }


                        <div className='bold fs-16 text-center'>Selamat Datang</div>

                            <div className='mt-2'>
                                <div className='fs-12 text-center'>Terima kasih atas kepercayaan Anda memilih Generali Indonesia. <br/>
                                Surat Pengajuan Asuransi Jiwa (SPAJ) Anda dengan No {SPAJs.spajHeader?.spajNumber} sudah berhasil diterima. <br/>
                                namun anda terlebih dahulu harus melakukan pembayaran untuk melanjutkan pengajuan SPAJ Anda. <br/>
                                Silakan menghubungi Agen Anda untuk informasi terkait SPAJ Anda.
                                </div>

                            </div>
                            <div className='mt-2'>
                                <button className='button-red' onClick={() => navigatePage()}>Mulai</button>
                            </div>
                        </div>
                        <div className='logo-link-welcome'>
                            <div>www.generali.co.id</div>
                        </div>
                    </div>
                    <div className='version'>
                        <div>{Version.appName} Version {Version.appVersion} {Envi.appStatus==="PROD"? "": "UAT"}</div>  
                    </div>

                </>
            )
        }

        if (inforce) {
            return (
                <>
                    <div className='logo-posisi'>
                        <img src="/images/generali-white.png" className='size-logo' />
                    </div>
                    <div className='position-cardfooter'>
                        <div className="card-container-welcome shadow-lg">

                            <div className='bold fs-16 text-center'>Terima kasih Atas kepercayaan Anda telah memilih Generali Indonesia.</div>

                            <div className='mt-2'>
                                <div className='fs-12 text-center'>
                                SPAJ Anda dengan No {SPAJs.spajHeader?.spajNumber} sudah berhasil diterima. <br/>
                                Setelah mendapat persetujuan, Anda akan menerima notifikasi SMS dan email, e-Polis dapat diakses/diunduh melalui aplikasi Gen iClick
                                </div>

                            <div className='fs-11 text-left mt-3'>
                                <strong><u>Disclaimer</u></strong><br/>
                                • PT Asuransi Jiwa Generali Indonesia berhak membatalkan dan/atau menangguhkan Polis sesuai ketentuan yang berlaku, apabila terdapat keterangan yang tidak benar atau tidak sesuai dengan keadaan yang sebenarnya pada SPAJ dan dokumen lainnya atau Tertanggung tidak memenuhi syarat untuk diasuransikan.<br/>
                                • Aplikasi Gen iClick dapat diunduh melalui AppStore atau PlayStore
                            </div>
                        </div>
                    </div>
                        <div className='logo-link-welcome'>
                            <div>www.generali.co.id</div>
                        </div>
                    </div>
                    <div className='version'>
                        <div>{Version.appName} Version {Version.appVersion} {Envi.appStatus==="PROD"? "": "UAT"}</div>  
                    </div>
                </>
            )
        }

        if (otherstat) {
            return (
                <>
                    <div className='logo-posisi'>
                        <img src="/images/generali-white.png" className='size-logo' />
                    </div>
                    <div className='position-cardfooter'>
                        <div className="card-container-welcome shadow-lg">

                            <div className='bold fs-16 text-center'>Terima kasih</div>

                            <div className='mt-2'>
                                <div className='fs-12 text-center'>Atas kepercayaan Anda telah memilih Generali Indonesia. <br/>
                                Surat Pengajuan Asuransi Jiwa (SPAJ) Anda dengan No {SPAJs.spajHeader?.spajNumber} tidak dapat diproses. Silakan menghubungi Agen Anda untuk informasi terkait SPAJ Anda.</div>
                            </div>
                        </div>
                        <div className='logo-link-welcome'>
                            <div>www.generali.co.id</div>
                        </div>
                    </div>
                    <div className='version'>
                        <div>{Version.appName} Version {Version.appVersion} {Envi.appStatus==="PROD"? "": "UAT"}</div>  
                    </div>
                    </>
            )
        }

        if (pendingDoc) {
            return (
                <>
                    <div className='logo-posisi'>
                        <img src="/images/generali-white.png" className='size-logo' />
                    </div>
                    <div className='position-cardfooter'>
                        <div className="card-container-welcome shadow-lg">

                        {serverTitle !== null && serverTitle !== undefined &&
                                <div className='bold fs-16 text-center'>{serverTitle}</div>
                            }
                        {serverTitle !== null && serverTitle !== undefined &&
                                <div className='mt-2'>
                                    <div className='fs-12 text-center'>{serverContent}<hr></hr></div>
                                </div>                            
                            }

                            <div className='bold fs-16 text-center'>Selamat Datang</div>

                            <div className='mt-2'>
                                <div className='fs-12 text-center'>Mohon membaca dan menandatangani dokumen berikut ini untuk melanjutkan proses Pengajuan Asuransi Jiwa Anda.</div>
                            </div>
                            <div className='mt-2'>
                                <button className='button-red' onClick={() => navigatePage()}>Mulai</button>
                            </div>
                        </div>
                        <div className='logo-link-welcome'>
                            <div>www.generali.co.id</div>
                        </div>
                    </div>
                    <div className='version'>
                        <div>{Version.appName} Version {Version.appVersion} {Envi.appStatus==="PROD"? "": "UAT"}</div>  
                    </div>
                    </>
            )
        }

        if (expired) {
            return (
                <>
                    <div className='logo-posisi'>
                        <img src="/images/generali-white.png" className='size-logo' />
                    </div>
                    <div className='position-cardfooter'>
                        <div className="card-container-welcome shadow-lg">

                            <div className='bold fs-16 text-center'>Selamat Datang!</div>
                            <div className='mt-2'>
                                <div className='fs-12 text-center'>Maaf, link ini telah expired. Silakan menghubungi Agen Anda untuk pengajuan SPAJ Anda.</div>
                            </div>
                        </div>
                        <div className='logo-link-welcome'>
                            <div>www.generali.co.id</div>
                        </div>
                    </div>
                    <div className='version'>
                        <div>{Version.appName} Version {Version.appVersion} {Envi.appStatus==="PROD"? "": "UAT"}</div>  
                    </div>
                </>
            )
        }

        if (invalidStat) {
            return (
                <>
                    <div className='logo-posisi'>
                        <img src="/images/generali-white.png" className='size-logo' />
                    </div>
                    <div className='position-cardfooter'>
                        <div className="card-container-welcome shadow-lg">

                            <div className='bold fs-16 text-center'>Selamat Datang!</div>
                            <div className='mt-2'>
                                <div className='fs-12 text-center'>{invalidWording}</div>
                            </div>
                        </div>
                        <div className='logo-link-welcome'>
                            <div>www.generali.co.id</div>
                        </div>
                    </div>
                    <div className='version'>
                        <div>{Version.appName} Version {Version.appVersion} {Envi.appStatus==="PROD"? "": "UAT"}</div>  
                    </div>
                </>
            )
        }

        if (serverStat) {
            return (
                <>
                    <div className='logo-posisi'>
                        <img src="/images/generali-white.png" className='size-logo' />
                    </div>
                    <div className='position-cardfooter'>
                        <div className="card-container-welcome shadow-lg">

                            <div className='bold fs-16 text-center'>{serverTitle}!</div>
                            <div className='mt-2'>
                                <div className='fs-12 text-center'>{serverContent}</div>
                            </div>
                        </div>
                        <div className='logo-link-welcome'>
                            <div>www.generali.co.id</div>
                        </div>
                    </div>
                    <div className='version'>
                        <div>{Version.appName} Version {Version.appVersion} {Envi.appStatus==="PROD"? "": "UAT"}</div>  
                    </div>
                </>
            )
        }

        return (
            <>
                <div className='logo-posisi'>
                    <img src="/images/generali-white.png" className='size-logo' />
                </div>
                <div className='position-cardfooter'>
                    <div className="card-container-welcome shadow-lg">

                        {serverTitle !== null && serverTitle !== undefined &&
                            <div className='bold fs-16 text-center'>{serverTitle}</div>
                        }
                        {serverTitle !== null && serverTitle !== undefined &&
                            <div className='mt-2'>
                                <div className='fs-12 text-center'>{serverContent}<hr></hr></div>
                            </div>                            
                        }


                        <div className='bold fs-16 text-center'>Selamat Datang!</div>
                        <div className='mt-2'>
                            <div className='fs-12 text-center'>Mohon membaca dan menandatangani dokumen berikut ini untuk melanjutkan proses Pengajuan Asuransi Jiwa Anda.</div>
                        </div>
                        <div className='mt-2'>
                            <button className='button-red' onClick={() => navigatePage()}>Mulai</button>
                        </div>
                    </div>
                    <div className='logo-link-welcome'>
                        <div className='links'>www.generali.co.id</div>
                    </div>
                </div>
                <div className='version'>
                    <div>{Version.appName} Version {Version.appVersion} {Envi.appStatus==="PROD"? "": "UAT"}</div>  
                </div>
            </>
        );
    }

    return (
        <>
            {loading == true && <Spinners />}
            {/* <LoadingOverlay active={loading} text="Loading..." spinner> */}
            <div>
                <Row className="g-0 welcome-container">
                    <Col xs={12} sm={12} md={12} lg={6}>
                        <div className="left-container position-relative">
                            <div className="icon-container">
                                <img src="/images/generali-white.png" className="icon-gen size-logo" />
                            </div>
                            <ReturnData />
                        </div>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={6}>
                        <div className='logo-posisi-potrait'>
                            {/* Use root-relative paths so assets load under /banca subroutes */}
                            <img src="/images/header2.png" className='size-logo'/>
                        </div>
                        <div>
                            <img src="/images/loginpage.jpg" className="ilustration welcomePage" />
                        </div>
                    </Col>
                </Row>
            </div>
            {/* </LoadingOverlay> */}
        </>
    )


}

export default Welcome;